<template>
  <div :class="bem()" v-if="show" v-backFn="{ show: show, closeFn: 'close' }">
    <div v-if="spuInfo && spuInfo.commoditySpu" :class="{ 'specification-layer': true, bankabc: clientEnv.isBankabc }">
      <!--商品基本信息，图片、描述、价格-->
      <section class="section-summary" v-statusBar="'marginTop'">
        <!--关闭按钮-->
        <i class="close" @click="close(true)" />
        <sku-product
          :spuInfo="spuInfo"
          :skuInfo="skuInfo"
          :checkedInfo="checkedInfo"
          :totalPrice="totalPrice"
        ></sku-product>
      </section>

      <!-- 选项-->
      <div id="layerContent" class="layer-content" @scroll="onscroll">
        <sku-specs
          :operateType="operateType"
          :spuInfo="spuInfo"
          :skuId="skuId"
          :specMain="spuInfo.specItem.specMain"
          :specMainSeq="spuInfo.specItem.specMainSeq"
          :skuSpecList="spuInfo.specItem.skuSpecList"
          :specItemSeq="spuInfo.specItem.specItemSeq"
          :defaultSkuId="spuInfo.defaultSkuId"
          @specItemClick="specItemClick"
          @skuChange="skuChange"
        ></sku-specs>

        <!--套餐-->
        <sku-suites
          v-if="option.suite"
          :skuInfo="skuInfo"
          :suites="skuInfo.suites"
          :currentSuite="currentSuite"
          @suiteClick="suiteClick"
          @suiteChange="suiteChange"
        ></sku-suites>

        <!--花呗信息-->
        <sku-installment
          v-if="option.installment && !skuInfo.commodityDepositeVo"
          :skuId="skuId"
          :money="totalPrice"
          :fqNum="fqNum"
          @fqNumChange="fqNumChange"
        ></sku-installment>

        <!--镭雕服务-->
        <sku-laser v-if="option.laser && skuInfo.laserSign" :checked="laser" @laserChange="laserChange"></sku-laser>

        <!--数量-->
        <sku-number
          v-if="option.number"
          :skuInfo="skuInfo"
          :number="number"
          :maxNum="Number(maxNum)"
          @numberChange="numberChange"
          @numberClick="numberClick"
        ></sku-number>

        <!--服务-->
        <sku-service
          v-if="option.service"
          :spuInfo="spuInfo"
          :checkedService="service"
          @serviceChange="serviceChange"
          @serviceClick="serviceClick"
        ></sku-service>
      </div>

      <!-- 操作 -->
      <div class="layer-footer">
        <slot v-bind:checkedInfo="checkedInfo">
          <div class="operation">
            <v-button type="primary" size="large" :disabled="btnOption.isDisabled" @click="confirm">
              {{ btnOption.text }}
            </v-button>
          </div>
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
import SkuProduct from './components/sku-product'
import SkuSpecs from './components/sku-specs'
import SkuSuites from './components/sku-suites'
import SkuInstallment from './components/sku-installment'
import SkuLaser from './components/sku-laser'
import SkuNumber from './components/sku-number'
import SkuService from './components/sku-service'
import API from 'api'
import create from '../create'
import clientEnv from '@/utils/clientEnv'
import trackData from './trackData'

export default create({
  name: 'sku',
  components: {
    SkuProduct,
    SkuSpecs,
    SkuSuites,
    SkuInstallment,
    SkuLaser,
    SkuNumber,
    SkuService
  },
  data() {
    return {
      trackData: {},
      clientEnv,
      operateType: 1, // 操作类型， 1 普通购买， 2 拼购，3 拼购单独购买 4 抢购
      goodsType: 1, // 商品类型 1 手机， 2 配件
      params: {}, // 规格弹层打开时携带的参数
      number: 1, // 数量
      fqNum: 0, // 分期数
      laser: false, // 是否选中镭雕,
      suiteId: 0, // 选中的套餐Id
      service: {}, // 选中的服务
      spuInfo: {},
      skuInfo: {},
      checkedSpecData: {}, // 选中的规格信息
      option: {
        suite: true,
        installment: true,
        laser: true,
        number: true,
        service: true
      },
      initData: {},
      show: false
    }
  },
  computed: {
    // 当前skuId
    skuId() {
      return this.skuInfo && this.skuInfo.id
    },
    // 当前选中的套餐信息
    currentSuite() {
      if (this.option.suite && this.skuInfo.suites && this.skuInfo.suites.length) {
        if (this.suiteId == 0) {
          return {
            id: 0,
            name: '官方标配',
            totalPrice: 0
          }
        } else {
          return (
            this.skuInfo.suites.find(suite => {
              return suite.id == this.suiteId
            }) || {}
          )
        }
      }

      return {}
    },

    // 商品单价，单价*数量
    singlePrice() {
      let price = this.skuInfo ? this.skuInfo.salePrice : 0
      // 如果是拼购，取拼购价
      if (this.operateType == 2) {
        const grouponInfo = this.spuInfo.grouponActInfos
        if (grouponInfo && grouponInfo[this.skuId]) {
          price = grouponInfo[this.skuId].grouponPrice
        }
      }
      // 如果是套餐，则不管是否抢购状态，都取套餐价
      if (this.currentSuite.id) {
        price = this.currentSuite.totalPrice
      }
      // 加上服务的价格
      Object.values(this.service).forEach(item => {
        if (item && item.salePrice) {
          price += item.salePrice
        }
      })

      return price
    },
    // 商品单价，单价*数量
    totalPrice() {
      return this.number * this.singlePrice
    },
    // 最大购买限制
    maxNum() {
      // 拼购活动，去活动数量限制，如果是定金预售，取定金预售数量；如果是抢购且非套餐，取抢购数量；如果是秒杀，取秒杀数量；
      if (this.operateType == 2) {
        return this.spuInfo?.commons?.grouponCommodityNumLimit
      } else if (this.skuInfo.commodityDepositeVo) {
        return 1
      } else if (this.skuInfo.commodityActVo && !this.currentSuite.id) {
        return this.skuInfo.commodityActVo.perOrderCount
      } else {
        return this.spuInfo.commons.normalCommodityNumLimit
      }
    },
    // 选中的信息
    checkedInfo() {
      return {
        skuId: this.skuId,
        number: this.number,
        fqNum: this.fqNum,
        laser: this.laser,
        currentSuite: this.currentSuite,
        service: this.service
      }
    },
    // 按钮文案
    btnOption() {
      const skuInfo = this.skuInfo
      let { laser, fqNum } = this.checkedInfo
      let text = '确定'
      let isDisabled = false
      if (this.operateType == 2) {
        if (fqNum) {
          text = '分期购买'
        } else if (laser) {
          text = '添加镌刻信息'
        } else if (this.params && this.params.position == 1) {
          // 只有拼购商详已选模块调起的才会显示一键开团，其他均为确定
          text = '一键开团'
        }
      } else {
        if (skuInfo.marketable == 0) {
          text = '商品已下架'
          isDisabled = true
        } else if (skuInfo.skuStatus.hasStore == 0) {
          text = '商品暂时缺货'
          isDisabled = true
        } else if (fqNum) {
          text = '分期购买'
        } else if (laser) {
          text = '添加镌刻信息'
        }
      }

      return {
        text,
        isDisabled
      }
    }
  },
  watch: {
    show(val) {
      if (val) {
        this.onscroll()
      }
    },
    'skuInfo.id'() {
      // sku变化后重置选中的信息
      this.resetCheckedItems()
    },
    checkedInfo: {
      deep: true,
      immediate: true,
      handler(info) {
        this.$emit('checkedInfoChange', info)
      }
    }
  },
  mounted() {
    // 初始化数据
    this.initInfo()
  },
  methods: {
    initInfo() {
      if (!this.initData) return false

      const option = this.option
      const checked = this.initData
      if (option.suite && checked.currentSuite && checked.currentSuite.id) {
        this.suiteId = checked.currentSuite.id
      }
      if (option.installment && checked.fqNum) {
        this.fqNum = checked.fqNum
      }
      if (option.laser) {
        this.laser = !!checked.laser
      }
      if (option.number && checked.number) {
        this.number = checked.number
      }
      if (option.service && checked.service && Object.keys(checked.service).length) {
        this.service = checked.service
      }
    },
    skuChange(specData) {
      // 记录选中数据
      this.checkedSpecData = specData
      if (specData.isSku && this.skuChangeCB) {
        this.skuChangeCB(
          Object.assign({}, this.checkedInfo, {
            skuId: specData.skuId
          })
        )
      }
    },
    // 重置选中的信息
    resetCheckedItems() {
      // 重置套餐
      this.suiteId = 0
      // 重置分期数
      this.fqNum = 0
      // 重置数量
      this.number = 1
      // 重置镭雕
      this.laser = false
    },
    // 切换套餐
    suiteChange(suiteId = 0) {
      this.suiteId = suiteId
    },

    // 切换分期
    fqNumChange(num) {
      this.fqNum = num
      this.installmentClick(num)
    },

    // 镭雕选中切换
    laserChange(isChecked) {
      this.laser = isChecked
      // 点击埋点
      this.laserClick(isChecked)
    },
    // 修改数量
    numberChange(num) {
      this.number = num
    },
    // 切换服务
    serviceChange(type, service) {
      // type 1 碎屏保， 2 延保， 3 后盖宝， 4 vivocare, 7 焕新宝， 0 取消所有
      if (type == 0) {
        this.service = {}
      } else if (type == 4) {
        // 如果是服务宝，则取消除焕新宝外的其他服务
        this.$delete(this.service, 1)
        this.$delete(this.service, 2)
        this.$delete(this.service, 3)
        this.$set(this.service, 4, service)
      } else if (type == 7) {
        this.$set(this.service, 7, service)
      } else {
        // 如果不是服务宝，则取消服务宝选中
        this.$delete(this.service, 4)
        this.$set(this.service, type, service)
      }
    },
    // 根据已选的规格项判断是否能组成完整的sku
    isSku() {
      return this.specMain.every(specId => !!(this.checkedSpecItem[specId] && this.checkedSpecItem[specId].id))
    },
    // 确定按钮
    confirm() {
      // 如果按钮禁用，则不作任何响应
      if (this.btnOption.isDisabled || !this.checkedSpecData.isSku) return false

      // 拼购相关上报此埋点
      if (this.operateType == 2) {
        API.logAll({
          cfrom: '081|064|01|077',
          event_id: '081|064|01|077',
          taskType: 1,
          goodtype: this.goodsType,
          goodid: this.skuInfo.id,
          module: 1, // 1常规团， 2 1分团，目前只有常规团
          pagetype: 0
        })
      }
      // 确认回调
      this.confirmCb && this.confirmCb({ ...this.checkedInfo, totalPrice: this.totalPrice })
    },
    // 关闭规格选择弹框
    close(isManual) {
      // 如果是手动关闭的，需要主动进行回退
      if (isManual) {
        history.back()
      }
      this.skuCloseCB && this.skuCloseCB(this.checkedInfo)
    },

    // 埋点相关事件
    // 滚动到底部曝光
    onscroll() {
      try {
        let sh = document.getElementById('layerContent').scrollHeight
        let st = document.getElementById('layerContent').scrollTop
        let ch = document.getElementById('layerContent').clientHeight
        if (Math.ceil(st + ch) === sh) {
          API.logAll(this.trackData && this.trackData.specBottomShow())
        }
      } catch (e) {}
    },
    // 规格项点击
    specItemClick({ specName, specItemName }) {
      API.logAll(
        trackData.specItemClick({
          specName,
          specItemName
        })
      )
    },
    // 套餐点击
    suiteClick(suite) {
      let data = null
      if (suite.id) {
        data = this.trackData.suiteClick({
          id: suite.id,
          name: suite.name + ' ¥' + suite.totalPrice + ' 省¥' + suite.discountAmount
        })
      } else {
        data = trackData.suiteClick({ id: 0, name: '官方标配 不享受优惠' })
      }
      API.logAll(data)
    },
    // 镭雕点击
    laserClick(checked) {
      API.logAll(
        trackData.laserClick({
          checked,
          goodtype: this.goodsType,
          goodid: this.skuId
        })
      )
    },
    // 分期点击
    installmentClick(fqNum) {
      if (trackData.installmentClick) {
        API.logAll(this.trackData.installmentClick(fqNum))
      }
    },
    // 服务点击
    serviceClick(service) {
      if (trackData.serviceClick) {
        API.logAll(
          this.trackData.serviceClick({
            id: service.id,
            name: service.name
          })
        )
      }
    },
    // 数量点击
    numberClick({ num, type }) {
      if (trackData.numberClick) {
        API.logAll(
          this.trackData.numberClick({
            num,
            type
          })
        )
      }
    }
  }
})
</script>

<style lang="scss" src="./index.scss"></style>
